import React, { createRef } from 'react';
import { IonInput, IonChip, IonSearchbar, IonActionSheet, IonBackButton, IonButtons, IonListHeader, IonCardHeader, IonCardContent, IonCardTitle, IonCardSubtitle, IonCard, IonFab, IonFabButton, IonIcon, IonContent, IonHeader, IonItem, IonLabel, IonList, IonPage, IonTitle, IonToolbar, withIonLifeCycle } from '@ionic/react';
import { Doughnut } from 'react-chartjs-2';

class Chart extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {

        if (this.props.data) {

            let isAllZero = true;

            for (let i = 0; i < this.props.data.length; i++) {
                if (this.props.data[i] !== 0) {
                    isAllZero = false;
                    break;
                }
            }

            if (isAllZero) {
                return(
                    <div
                        className="chart-wrapper"
                        style={{ borderTop: this.props.borderTop }}
                    >
                        <h2>{this.props.title}</h2>
                        <p className="no-data">{window.ln.noData}</p>
                    </div>
                )
            }
            
        }

        return (
            <div 
                className="chart-wrapper"
                style={{ borderTop: this.props.borderTop }}
            >
                <h2>{this.props.title}</h2>
                <Doughnut
                    width={300}
                    height={300}
                    options={{
                        animation: {
                            duration: 0
                        },
                        elements: {
                            arc: {
                                borderWidth: 0
                            }
                        },
                        legend: {
                            display: false,
                        },
                    }} data={{
                        labels: this.props.labels,
                        datasets: [
                            {
                                label: "label",
                                fill: true,
                                lineTension: 0.1,
                                borderColor: 'rgba(75,192,192,1)',
                                borderCapStyle: 'butt',
                                borderDash: [],
                                borderDashOffset: 0.0,
                                borderJoinStyle: 'miter',
                                pointBorderColor: 'rgba(75,192,192,1)',
                                pointBackgroundColor: '#fff',
                                pointBorderWidth: 1,
                                pointHoverRadius: 5,
                                pointHoverBackgroundColor: 'rgba(75,192,192,1)',
                                pointHoverBorderColor: 'rgba(220,220,220,1)',
                                pointHoverBorderWidth: 2,
                                pointRadius: 1,
                                pointHitRadius: 10,
                                data: this.props.data,
                                backgroundColor: this.props.colors || window.getChartColorI(),
                            }
                            ]
                    }}
                />
                <div className="legend">
                    { (this.props.labels.map((label, i) => {
                        return (
                            <div key={label} className="legend-item">
                                <div className="color" style={{ backgroundColor: this.props.colors ? this.props.colors[i] : window.getChartColorI(i) }}></div>
                                <div className="label">{label} {this.props.data[i]} </div>
                            </div>
                        )
                    })) }
                </div>
            </div>
        );
    }

};


export default withIonLifeCycle(Chart);
